import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'appDecimalFormat',
})
export class DecimalFormatPipe implements PipeTransform {
    transform(
        value: number | null | undefined,
        minFractionDigits: number = 2,
        maxFractionDigits: number = 2
    ): string {
        if (value == null) return '';

        return value.toLocaleString('pt-BR', {
            minimumFractionDigits: minFractionDigits,
            maximumFractionDigits: maxFractionDigits
        });
    }
}
